import * as types from './ActionTypes';
import Spotify from 'spotify-web-api-js';
import fetch from 'cross-fetch';
const spotifyApi = new Spotify();

const tokenURL = 'https://s0pagy2hj3.execute-api.us-east-1.amazonaws.com/prod/spotify-authorize/';

/** set the app's access and refresh tokens */
export function setTokens(accessToken, refreshToken) {
  if (accessToken) {
    spotifyApi.setAccessToken(accessToken);
  }
  return { type: types.SPOTIFY_TOKENS, accessToken, refreshToken };
}

export function getCurrentUser() {
  return { type: types.GET_CURRENT_USER };
}

export function removeCurrentUser(){
  return { type: types.REMOVE_CURRENT_USER };
}

export function refreshToken(){
  return dispatch => {
    const refresh = localStorage.getItem('refreshToken');
    return fetch(tokenURL+'refresh?refresh='+refresh)
    .then(response => response.json())
    .then(data => {
      console.log(data);
      dispatch(setTokens(data.access_token));
    });
  }
}

function isTokenValid(){
  let tokenExpiration = localStorage.getItem('tokenExpiration');
  if(tokenExpiration){
    let currentTime = new Date().toISOString();
    if(currentTime > tokenExpiration){
      return false;
    }else{
      return true;
    }
  }else{
    return false;
  }
}

export function isLoggedIn(){
  return dispatch => {
    if(isTokenValid()){
      dispatch({ type: types.SPOTIFY_USER_LOGGED_IN, status: true});
    }else if(localStorage.getItem('refreshToken')){
      dispatch(refreshToken());
    }else{
      dispatch({ type: types.SPOTIFY_USER_LOGGED_OUT, status: false });
      //dispatch({ type: types.REMOVE_CURRENT_USER });
    }
  };
}

/* get the user's info from the /me api */
export function getMyInfo() {
  return dispatch => {
    dispatch({ type: types.SPOTIFY_ME_BEGIN});
    return spotifyApi.getMe().then(data => {
      dispatch({ type: types.SPOTIFY_ME_SUCCESS, data: data });
    }).catch(e => {
      dispatch({ type: types.SPOTIFY_ME_FAILURE, error: e });
    });
  };
}

export function getPlaylists(user, offset = 0, limit, lists = 0){
  return dispatch => {
    spotifyApi.getUserPlaylists(user, {limit: 50, offset})
    .then(playlists => {
      lists = [...lists, ...playlists.items];
      if(playlists.next){
        let offset = playlists.offset + playlists.limit;
        dispatch(getPlaylists(user, offset, 50, lists));
      }else{
        dispatch({ type: types.SPOTIFY_PLAYLIST_SUCCESS, lists });
      }
    });
  };
}

export function getPlaylist(user, list){
  return dispatch => {
    return spotifyApi.getPlaylist(user, list)
    .then(playlist => {
      dispatch({ type: types.SPOTIFY_GET_PLAYLIST_SUCCESS, playlist });
    }).catch(e => {
      dispatch({ type: types.SPOTIFY_GET_PLAYLIST_FAILURE, error: e});
    });
  };
}

export function createPlaylist(userId, name){
  return dispatch => {
    return spotifyApi.createPlaylist(userId, {name: name, public: false})
    .then(playlist => {
      dispatch({ type: types.SPOTIFY_CREATE_PLAYLIST_SUCCESS, playlist });
    }).catch(e => {
      dispatch({ type: types.SPOTIFY_CREATE_PLAYLIST_FAILURE, error: e });
    });
  };
}

export function deletePlaylist(userId, playlistId){
  return dispatch => {
    return spotifyApi.unfollowPlaylist(userId, playlistId)
    .then(() => {
      dispatch({ type: types.SPOTIFY_UNFOLLOW_PLAYLIST_SUCCESS });
    })
    .catch(e => {
      dispatch({ type: types.SPOTIFY_UNFOLLOW_PLAYLIST_FAILURE, error: e });
    });
  };
}

export function explicitCheck(list){
  return dispatch => {
    dispatch({ type: types.PLAYLIST_CHECK, list});
  };
}

function filterTracks(items){
  const clean = items.filter(item => item.track.explicit !== true);
  return clean.map(item => {
    return item.track.uri;
  });
}

export function addTracks(userId, playlistId, tracks){
  let uris = filterTracks(tracks);
  return dispatch => {
    return spotifyApi.addTracksToPlaylist(userId, playlistId, uris)
    .then(playlist => {
      console.log('response to adding songs', playlist);
      dispatch({ type: types.SPOTIFY_ADD_TRACKS_SUCCESS, playlist });
    });
    
  };
}


// WEBPACK FOOTER //
// ./src/actions/index.js